import TotalInformationCard from './TotalInformationCard.vue';

export { TotalInformationCard };
export default TotalInformationCard;
